const STRIPE_API_VERSION = '2019-02-11';

export default STRIPE_API_VERSION;
